export default __webpack_public_path__ + "971f722f7a44f391aa4ac6ecb6f75cb8.png";